export let UploaderId = /*#__PURE__*/function (UploaderId) {
  UploaderId["VIDEO_MAIN"] = "main";
  UploaderId["VIDEO_COVER"] = "cover";
  UploaderId["VIDEO_TRAILER"] = "trailer";
  UploaderId["VIDEO_POSTER"] = "poster";
  UploaderId["CHANNEL_COVER"] = "channel-cover";
  UploaderId["EMBED_LOGO"] = "embed-logo";
  UploaderId["EMBED_LOGO_1"] = "EMBED_LOGO_1";
  UploaderId["EMBED_LOGO_2"] = "EMBED_LOGO_2";
  UploaderId["EMBED_LOGO_3"] = "EMBED_LOGO_3";
  UploaderId["EMBED_LOGO_NEW"] = "EMBED_LOGO";
  UploaderId["VIDEO_CARD_IMAGE"] = "video-card-image";
  return UploaderId;
}({});
//# sourceMappingURL=uploader-id.js.map